export default "__VITE_ASSET__DtYStC1J__"